import React, { Fragment, useState } from 'react'
import { useMutation } from 'react-apollo-hooks'
import styled from 'react-emotion'
import { ga } from '../../application'
import { colors } from '../../styles'
import Markdown from 'react-markdown'
import getText from '../strings'
import * as Mutations from '../mutations'

const ModalHeader = styled('div')`
  display: flex;
  justify-content: space-between;

  .pictogram {
    height: 40px;
    width: 40px;
    cursor: pointer;
  }
`

const BookingDetails = styled('div')`
  display: flex;
  align-items: center;
`

const OptionsBox = styled('div')`
  border-top: 1px solid ${colors.tui_border};
  margin-top: 20px;
  padding-top: 20px;
  select {
    width: 300px;
    height: 40px;
    width: 100%;
  }

  textarea {
    height: 150px;
    width: 100%;
    margin-top: 20px;
  }

  input {
    width: 100%;
  }
`

const SelectedOptionContent = styled('div')`
  margin-top: 10px;
  button {
    margin-top: 10px;
  }
  ul {
    padding-left: 20px;
    list-style: unset;
  }
`

export default ({ booking, options }) => {
  const [selectedOption, setSelectedOption] = useState(null)
  const [userMessage, setUserMessage] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const addCase = useMutation(Mutations.addSelfServiceCase)

  const handleSelectedOption = (e) => {
    const option = options.filter((o) => o.id === e.target.value)[0]
    const selectedOption = option || null
    setSelectedOption(selectedOption)
  }

  const handleSubmit = () => {
    addCase({
      variables: {
        data: {
          bookingNumber: booking.bookingNumber,
          id: selectedOption.id,
          message: userMessage,
        },
      },
    })

    setSubmitted(true)
    ga.buttonClick('selfservice-create-case-submit')
  }

  if (submitted) {
    return (
      <Fragment>
        <ModalHeader>
          <div>
            <h2>{getText('selfservice', 'confirmation', 'title')}</h2>
          </div>
        </ModalHeader>
        <Markdown source={getText('selfservice', 'confirmation', 'description')} />
      </Fragment>
    )
  }

  return (
    <Fragment>
      <ModalHeader>
        <div>
          <h2>{getText('selfservice', 'newCase', 'title')}</h2>
          <BookingDetails>
            <strong>{getText('selfservice', 'newCase', 'bookingLabel')}:&nbsp;</strong>
            <span>
              {booking.products[0].country || ''} {booking.startDate} ({booking.bookingNumber})
            </span>
            <p>{getText('selfservice', 'newCase', 'substring-1')}</p>
            <p>{getText('selfservice', 'newCase', 'substring-2')}</p>
          </BookingDetails>
        </div>
      </ModalHeader>
      <OptionsBox>
        <select onChange={(e) => handleSelectedOption(e)}>
          <option defaultValue>{getText('selfservice', 'newCase', 'options', 'placeholder')}</option>
          {options.map((o) => (
            <option value={o.id} key={o.id}>
              {o.title}
            </option>
          ))}
        </select>
        {selectedOption && (
          <SelectedOptionContent>
            <h3>{selectedOption.title}</h3>
            <div>
              <Markdown source={selectedOption.description} linkTarget="_blank" />
            </div>
            {selectedOption.id !== '0' && (
              <div>
                <textarea value={userMessage} onChange={(e) => setUserMessage(e.target.value)} placeholder={getText('selfservice', 'newCase', 'messagePlaceholder')} />
                <button disabled={!userMessage.trim()} onClick={handleSubmit} className="btn btn-function">
                  {getText('selfservice', 'newCase', 'submit')}
                </button>
              </div>
            )}
          </SelectedOptionContent>
        )}
      </OptionsBox>
    </Fragment>
  )
}
